import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'antd';
import NewCustomButton from '../Common/NewCustomButton';
import { NewCloseIcon, NewUpdateIcon } from '../Common/Icons';
import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { ButtonTypes } from '../Common/CustomButton';

const NonRecurringTaskModal = ({
  isModalOpen = false,
  onConfirm = () => {},
  onCancel = () => {},
  modalType = '',
  modalHeader = '',
  showDeleteMsg = false,
  actionType = '',
  saveChangesAction = false,
  className = '',
}) => {
  const trans = useSelector(translator);
  return (
    <div className="">
      <Modal
        title={modalHeader}
        centered
        open={isModalOpen}
        footer={null}
        closable={false}
        className="task-modal-conatiner"
      >
        <div className="taskmodal">
          <div className={`${showDeleteMsg ? '' : 'taskmodifydescription'} taskmodaldescription`}>
            {saveChangesAction ? (
              <p>
                <span style={{ fontWeight: '400' }}>
                  {trans('CHANGES_HAVEBEEN_L')}{' '}
                  <span style={{ fontWeight: '700' }}>{trans('MADE_L')}</span> {trans('BUT_L')}{' '}
                  <span style={{ fontWeight: '700' }}>{trans('NOTSAVED_L')}</span>
                </span>{' '}
              </p>
            ) : (
              <p>
                <span style={{ fontWeight: '400' }}>
                  {trans('YOUAREABOUTTO')} {actionType} {trans('THIS_L')}
                </span>{' '}
                {modalType}.
                <br />
                {showDeleteMsg && (
                  <p style={{ fontWeight: '400' }}>
                    {trans('ITWILLBEREMOVEDFROMTHE')}{' '}
                    <span style={{ fontWeight: '700' }}>{`${trans('SCHEDULE_L')}.`}</span>
                  </p>
                )}
              </p>
            )}

            {saveChangesAction ? (
              <span>{trans('AREYOUSUREYOUWANTTODISCRADCHANGES?')}</span>
            ) : (
              <span>{trans('AREYOUSURE')}</span>
            )}
          </div>
          <div className={`taskmodalbutton ${className}`}>
            <NewCustomButton
              className="cancel"
              onClick={onCancel}
              label={trans('CANCEL')}
              icon={<NewCloseIcon className="cancel-icon" />}
            />
            <NewCustomButton
              className="confirm"
              type={ButtonTypes.primary}
              label={trans('YES')}
              icon={<NewUpdateIcon className={'update-icon-enabled'} />}
              onClick={onConfirm}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

NonRecurringTaskModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default NonRecurringTaskModal;
